<!-- <div [id] = "chartdiv_id" class = "solid-gauge-chart"></div> -->
<div [id] = "'multiCircleChart'" class = "solid-gauge-chart"></div>
